import { render, staticRenderFns } from "./PacientesTabla.vue?vue&type=template&id=0a791032&scoped=true&lang=pug"
import script from "./PacientesTabla.vue?vue&type=script&lang=js"
export * from "./PacientesTabla.vue?vue&type=script&lang=js"
import style0 from "./PacientesTabla.vue?vue&type=style&index=0&id=0a791032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a791032",
  null
  
)

export default component.exports